const commentItems = [
  {
    name: '匿名用户A***',
    time: '3小时前',
    text: '这个平台真的太强了，每天都在刷新我的认知。黑料视频更新速度没得说，好多爆料都是这里首发，已经推荐给身边所有朋友了。',
    likes: 238,
  },
  {
    name: '吃瓜群众B***',
    time: '6小时前',
    text: '从微博追过来的，发现这里的料更全更详细。体内精69xxxxx黑料社的调查报道质量很高，不是那种标题党，每篇都有实锤。',
    likes: 186,
  },
  {
    name: '资深用户C***',
    time: '10小时前',
    text: '用了半年多了，见证了黑料社区从几千人到现在的规模。最欣赏的是对爆料人隐私的保护做得很到位，让人敢说真话。',
    likes: 421,
  },
  {
    name: '新用户D***',
    time: '16小时前',
    text: '朋友介绍来的，一开始以为又是那种标题党网站，结果发现内容真的很硬核。24小时更新确实名不虚传，半夜都有新料上线。',
    likes: 97,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            用户评论
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            听听社区用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 text-sm font-bold shrink-0">
                  {item.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed flex-1 mb-3">
                &ldquo;{item.text}&rdquo;
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line" />
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}